"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Avatar_1 = require("@material-ui/core/Avatar");
var Divider_1 = require("@material-ui/core/Divider");
var Grid_1 = require("@material-ui/core/Grid");
var Link_1 = require("@material-ui/core/Link");
var Menu_1 = require("@material-ui/core/Menu");
var Paper_1 = require("@material-ui/core/Paper");
var withStyles_1 = require("@material-ui/styles/withStyles");
var UserAccounts_1 = require("src/bookstore/UserAccounts");
var Routing_1 = require("src/Routing");
var styles_1 = require("./styles");
var CurrentUserDropdownMenu = /** @class */ (function (_super) {
    __extends(CurrentUserDropdownMenu, _super);
    function CurrentUserDropdownMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.onOpenClick = function (e) {
            _this.setState({ anchorEl: e.currentTarget });
        };
        _this.handleClose = function () {
            _this.setState({ anchorEl: undefined });
        };
        _this.state = {};
        return _this;
    }
    CurrentUserDropdownMenu.prototype.render = function () {
        var _a = this.props, classes = _a.classes, currentUser = _a.currentUser;
        var firstChar = currentUser.firstName ? currentUser.firstName.charAt(0) : 'A';
        var lastChar = currentUser.lastName ? currentUser.lastName.charAt(0) : 'A';
        return (React.createElement(React.Fragment, null,
            React.createElement(Avatar_1.default, { onClick: this.onOpenClick, className: classes.currentUserMenuButton }, firstChar + lastChar),
            React.createElement(Menu_1.default, { elevation: 0, getContentAnchorEl: null, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                }, anchorEl: this.state.anchorEl, keepMounted: true, open: Boolean(this.state.anchorEl), onClose: this.handleClose },
                React.createElement(Paper_1.default, { className: classes.currentUserMenu },
                    React.createElement(Grid_1.default, { container: true, direction: "column" },
                        React.createElement(Link_1.default, { target: "_blank", className: classes.currentUserMenuLink, 
                            // tslint:disable-next-line: max-line-length
                            href: "https://docs.google.com/forms/d/e/1FAIpQLSfUJ2aydK0AmoKhlDFXspKonj1C89YiiUTSGzsEQcvMh2S2Mw/viewform" }, "Report A Bug"),
                        React.createElement(Link_1.default, { component: Routing_1.RouterLink('/editUser'), className: classes.currentUserMenuLink }, "Settings"),
                        React.createElement(Divider_1.default, { light: true, style: { margin: '8px 0' } }),
                        React.createElement(UserAccounts_1.LogOutLink, { className: classes.currentUserMenuLink }, "Logout"))))));
    };
    return CurrentUserDropdownMenu;
}(React.Component));
exports.default = withStyles_1.default(styles_1.default)(CurrentUserDropdownMenu);
